import {
  AMT_2025_TRAN_AMT_WHITE_LIST,
  MAX_STATISTIC_ITEM_FLOAT_VALUE_SIGNS_AFTER_COMMA,
  MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
  MEASURE_TEMPLATE_VALUE,
  MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
  ONE_MINUTE_IN_SECONDS,
  SECONDS_VALIDATION_MULTIPLIER,
} from '@/constants';
import {Ambassador, ambassadorsWishes} from '@/resources/ambassadors';
import {NamedResourcesStatisticItem, NamedStatisticContent, NamedValidationConfig} from '@/resources/index';
import {CHARITY_ITEM_NAME} from '@/resources/statisticItems';
import {BonusRedirectType, StatisticItemValidationType} from '@/types';

export const mockStatisticContent: NamedStatisticContent[] = [
  {
    name: 'favorite_pets_shop',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш любимый зоомагазин.',
        plurals: [],
      },
      description: {
        text: 'Ваш любимый зоомагазин %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'pets_total_spends',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Ваши общие траты на питомцев.',
        plurals: [],
      },
      description: {
        text: `Вы потратили %yellowColor%$param1%yellowColor% (сложно в это поверить) ${MEASURE_TEMPLATE_VALUE} на товары для животных.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'travels_total_spends',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Ваши траты на путешествия.',
        plurals: [],
      },
      description: {
        text: `Вы потратили %yellowColor%$param1%yellowColor% (летая в самолете) ${MEASURE_TEMPLATE_VALUE} на отдых и путешествия.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'favorite_travel_company',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш незаменимый помощник в путешествиях.',
        plurals: [],
      },
      description: {
        text: 'Пользуйтесь услугами %yellowColor%$param1%yellowColor% дальше и откроете много разных направлений!',
        plurals: [],
      },
    },
  },
  {
    name: 'gym_total_quantity',
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1 ${MEASURE_TEMPLATE_VALUE}`,
        text: 'Вы посещали спорт зал.',
        plurals: ['раз', 'раза', 'раз'],
      },
      description: {
        text: `Вы посещали спорт зал %yellowColor%$param1%yellowColor% (без перерыва) ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['раз', 'раза', 'раз'],
      },
    },
  },
  {
    name: 'gym_total_spends',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Ваши общие траты на спорт.',
        plurals: [],
      },
      description: {
        text: `Общие траты на спорт составили %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'gym_average_visits',
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1 ${MEASURE_TEMPLATE_VALUE}`,
        text: 'В среднем вы посещали спорт зал в месяц.',
        plurals: ['раз', 'раза', 'раз'],
      },
      description: {
        text: `В среднем вы посещали %yellowColor%$param1%yellowColor% (невероятно) ${MEASURE_TEMPLATE_VALUE} в месяц.`,
        plurals: ['раз', 'раза', 'раз'],
      },
    },
  },
  {
    name: 'mobile_average_call_duration',
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1 ${MEASURE_TEMPLATE_VALUE}`,
        text: 'Вы тратили в среднем в месяц на разговоры.',
        plurals: ['минуту', 'минуты', 'минут'],
      },
      description: {
        text: `Вы тратили в среднем %yellowColor%$param1%yellowColor% (вот это да!) ${MEASURE_TEMPLATE_VALUE} в месяц на разговоры`,
        plurals: ['минуту', 'минуты', 'минут'],
      },
    },
  },
  {
    name: 'amt_2025_tran_amt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Ваша новогодняя трата',
        plurals: [],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} - ваша новогодняя трата.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'favorite_food',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш любимый продукт.',
        plurals: [],
      },
      description: {
        text: 'Ваш любимый продукт %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'favorite_drink',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Ваш любимый напиток.',
        plurals: [],
      },
      description: {
        text: 'Ваш любимый напиток %yellowColor%$param1%yellowColor%.',
        plurals: [],
      },
    },
  },
  {
    name: 'amt_2025_tran_dt',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1',
        text: 'Вы совершили покупку.',
        plurals: [],
      },
      description: {
        text: `Вы совершили ее в %yellowColor%$param1%yellowColor%`,
        plurals: [],
      },
    },
  },
  {
    name: 'min_spend_tran_amt_rur',
    parameterName: 'param1',
    content: {
      main: {
        title: '$param1 ₽',
        text: 'Столько стоила ваша самая скромная покупка в этом году.',
        plurals: [],
      },
      description: {
        text: `Ваша самая скромная покупка стоила %yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE}.`,
        plurals: ['рубль', 'рубля', 'рублей'],
      },
    },
  },
  {
    name: 'mb_sec',
    parameterName: 'param1',
    content: {
      main: {
        title: `$param1 ${MEASURE_TEMPLATE_VALUE}`,
        text: 'Столько времени вы провели в приложении Т‑Банка за год.',
        plurals: ['минута', 'минуты', 'минут'],
      },
      description: {
        text: `%yellowColor%$param1%yellowColor% ${MEASURE_TEMPLATE_VALUE} — время, которое вы провели в приложении Т‑Банка за год.`,
        plurals: ['минута', 'минуты', 'минут'],
      },
    },
  },
];

export const mockStatisticItems: NamedResourcesStatisticItem[] = [
  {
    name: 'minimalPurchase',
    title: 'Мини-леденец',
    imageLarge: {
      src: {
        png: 'static/ny25/minimalPurchase-320-2024-12-09-11-57-04.png 320w, static/ny25/minimalPurchase-760-2024-12-09-11-57-04.png 854w',
        avif: 'static/ny25/minimalPurchase-320-2024-12-09-11-57-04.avif 320w, static/ny25/minimalPurchase-760-2024-12-09-11-57-04.avif 854w',
        webp: 'static/ny25/minimalPurchase-320-2024-12-09-11-57-04.webp 320w, static/ny25/minimalPurchase-760-2024-12-09-11-57-04.webp 854w',
      },
      alt: 'Мини-леденец',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/minimalPurchaseSmall-320-2024-12-09-11-55-52.png 320w, static/ny25/minimalPurchaseSmall-854-2024-12-09-11-55-52.png 854w, static/ny25/minimalPurchaseSmall-1008-2024-12-09-11-55-52.png 1387w',
        avif: 'static/ny25/minimalPurchaseSmall-320-2024-12-09-11-55-52.avif 320w, static/ny25/minimalPurchaseSmall-854-2024-12-09-11-55-52.avif 854w, static/ny25/minimalPurchaseSmall-1008-2024-12-09-11-55-52.avif 1387w',
        webp: 'static/ny25/minimalPurchaseSmall-320-2024-12-09-11-55-52.webp 320w, static/ny25/minimalPurchaseSmall-854-2024-12-09-11-55-52.webp 854w, static/ny25/minimalPurchaseSmall-1008-2024-12-09-11-55-52.webp 1387w',
      },
      alt: 'Мини-леденец',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/minimalPurchaseSmallOpened-320-2024-12-09-11-53-47.png 320w, static/ny25/minimalPurchaseSmallOpened-680-2024-12-09-11-53-47.png 854w',
        avif: 'static/ny25/minimalPurchaseSmallOpened-320-2024-12-09-11-53-47.avif 320w, static/ny25/minimalPurchaseSmallOpened-680-2024-12-09-11-53-47.avif 854w',
        webp: 'static/ny25/minimalPurchaseSmallOpened-320-2024-12-09-11-53-47.webp 320w, static/ny25/minimalPurchaseSmallOpened-680-2024-12-09-11-53-47.webp 854w',
      },
      alt: 'Мини-леденец',
    },
    defaultStatistic: {
      title: '1.7 млрд ₽',
      description: 'Столько пожертвований сделали клиенты Т‑Банка за год. Вместе мы — сладкая фабрика заботы!',
    },
    extraDescription: 'Сладкая история о том, что размер конфеты не имеет значения!',
    bonusRedirectType: BonusRedirectType.Main,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Желаю тебе в новом году много маленьких радостей (в промежутках между большими). Кстати, в нашем мобильном приложении много поводов для радости!',
      buttonLink: {
        text: 'Порадовать открыткой',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/UsersContacts?utm_campaign=sp_ny25',
      },
    },
  },
  {
    name: 'assistant',
    title: 'Ассистентос',
    imageLarge: {
      src: {
        png: 'static/ny25/assistant-320-2024-12-09-11-33-11.png 320w, static/ny25/assistant-760-2024-12-09-11-33-11.png 854w',
        avif: 'static/ny25/assistant-320-2024-12-09-11-33-11.avif 320w, static/ny25/assistant-760-2024-12-09-11-33-11.avif 854w',
        webp: 'static/ny25/assistant-320-2024-12-09-11-33-11.webp 320w, static/ny25/assistant-760-2024-12-09-11-33-11.webp 854w',
      },
      alt: 'Ассистентос',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/assistantSmall-320-2024-12-09-11-32-12.png 320w, static/ny25/assistantSmall-681-2024-12-09-11-32-12.png 854w',
        avif: 'static/ny25/assistantSmall-320-2024-12-09-11-32-12.avif 320w, static/ny25/assistantSmall-681-2024-12-09-11-32-12.avif 854w',
        webp: 'static/ny25/assistantSmall-320-2024-12-09-11-32-12.webp 320w, static/ny25/assistantSmall-681-2024-12-09-11-32-12.webp 854w',
      },
      alt: 'Ассистентос',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/assistantSmallOpened-320-2024-12-09-11-30-58.png 320w, static/ny25/assistantSmallOpened-680-2024-12-09-11-30-58.png 854w',
        avif: 'static/ny25/assistantSmallOpened-320-2024-12-09-11-30-58.avif 320w, static/ny25/assistantSmallOpened-680-2024-12-09-11-30-58.avif 854w',
        webp: 'static/ny25/assistantSmallOpened-320-2024-12-09-11-30-58.webp 320w, static/ny25/assistantSmallOpened-680-2024-12-09-11-30-58.webp 854w',
      },
      alt: 'Ассистентос',
    },
    defaultStatistic: {
      title: '1.7 млрд ₽',
      description: 'Столько пожертвований сделали клиенты Т‑Банка за год. Вместе мы — сладкая фабрика заботы!',
    },
    extraDescription: 'Каждый диалог помогал решать ваши задачи. Новогодняя карамель из ваших бесед!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Krut].title,
      avatar: ambassadorsWishes[Ambassador.Krut].avatar,
      text: 'Желаю в новом году оставаться КРУТым мастером коммуникаций!',
      buttonLink: {
        text: 'Перейти в сервис',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Chat?botid=oleg_kids_bot',
      },
    },
  },
  {
    name: CHARITY_ITEM_NAME,
    title: 'Мишка краснокнижный',
    imageLarge: {
      src: {
        png: 'static/ny25/bear-320-2024-12-09-10-28-43.png 320w, static/ny25/bear-760-2024-12-09-10-28-43.png 854w',
        avif: 'static/ny25/bear-320-2024-12-09-10-28-43.avif 320w, static/ny25/bear-760-2024-12-09-10-28-43.avif 854w',
        webp: 'static/ny25/bear-320-2024-12-09-10-28-43.webp 320w, static/ny25/bear-760-2024-12-09-10-28-43.webp 854w',
      },
      alt: 'медведь',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/bearSmall-320-2024-11-28-12-41-54.png 320w, static/ny25/bearSmall-680-2024-11-28-12-41-54.png 854w',
        avif: 'static/ny25/bearSmall-320-2024-11-28-12-41-54.avif 320w, static/ny25/bearSmall-680-2024-11-28-12-41-54.avif 854w',
        webp: 'static/ny25/bearSmall-320-2024-11-28-12-41-54.webp 320w, static/ny25/bearSmall-680-2024-11-28-12-41-54.webp 854w',
      },
      alt: 'медведь',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/bearSmallOpened-320-2024-12-09-10-27-20.png 320w, static/ny25/bearSmallOpened-680-2024-12-09-10-27-20.png 854w',
        avif: 'static/ny25/bearSmallOpened-320-2024-12-09-10-27-20.avif 320w, static/ny25/bearSmallOpened-680-2024-12-09-10-27-20.avif 854w',
        webp: 'static/ny25/bearSmallOpened-320-2024-12-09-10-27-20.webp 320w, static/ny25/bearSmallOpened-680-2024-12-09-10-27-20.webp 854w',
      },
      alt: 'медведь',
    },
    defaultStatistic: {
      title: '1,7 млрд ₽',
      description: 'Столько пожертвований сделали клиенты Т‑Банка за год. Вместе мы — сладкая фабрика заботы!',
    },
    extraDescription: 'Ваша помощь очень важна для тех, кто в ней нуждается.',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Делайте добрые дела и пусть энергия добра возвращается к вам как кэшбэк в нашем банке!',
      buttonLink: null,
    },
  },
  {
    name: 'pets',
    title: 'Крабовые спинки',
    imageLarge: {
      src: {
        png: 'static/ny25/crab-320-2024-10-28-08-43-47.png 320w, static/ny25/crab-760-2024-10-28-08-43-47.png 854w',
        avif: 'static/ny25/crab-320-2024-10-28-08-43-47.avif 320w, static/ny25/crab-760-2024-10-28-08-43-47.avif 854w',
        webp: 'static/ny25/crab-320-2024-10-28-08-43-47.webp 320w, static/ny25/crab-760-2024-10-28-08-43-47.webp 854w',
      },
      alt: 'краб',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/crabSmall-320-2024-10-28-09-54-22.png 320w, static/ny25/crabSmall-680-2024-10-28-09-54-22.png 854w',
        avif: 'static/ny25/crabSmall-320-2024-10-28-09-54-22.avif 320w, static/ny25/crabSmall-680-2024-10-28-09-54-22.avif 854w',
        webp: 'static/ny25/crabSmall-320-2024-10-28-09-54-22.webp 320w, static/ny25/crabSmall-680-2024-10-28-09-54-22.webp 854w',
      },
      alt: 'краб',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/crabSmallOpened-320-2024-12-09-09-01-49.png 320w, static/ny25/crabSmallOpened-680-2024-12-09-09-01-49.png 854w',
        avif: 'static/ny25/crabSmallOpened-320-2024-12-09-09-01-49.avif 320w, static/ny25/crabSmallOpened-680-2024-12-09-09-01-49.avif 854w',
        webp: 'static/ny25/crabSmallOpened-320-2024-12-09-09-01-49.webp 320w, static/ny25/crabSmallOpened-680-2024-12-09-09-01-49.webp 854w',
      },
      alt: 'краб',
    },
    defaultStatistic: {
      title: '1.5 млн ₽',
      description: 'Потратили клиенты Т-Банк на товары для животных',
    },
    extraDescription: 'Сладкий рекорд в новогодней обертке!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Мы желаем вам тратить еще больше, используя наш потрясающий банк! Кстати, вы можете взять у нас ипотеку, если вдруг будет настроение!',
      buttonLink: null,
    },
  },
  {
    name: 'travel',
    title: 'Алая кепочка',
    imageLarge: {
      src: {
        png: 'static/ny25/hat-320-2024-10-28-09-05-28.png 320w, static/ny25/hat-760-2024-10-28-09-05-28.png 854w',
        avif: 'static/ny25/hat-320-2024-10-28-09-05-28.avif 320w, static/ny25/hat-760-2024-10-28-09-05-28.avif 854w',
        webp: 'static/ny25/hat-320-2024-10-28-09-05-28.webp 320w, static/ny25/hat-760-2024-10-28-09-05-28.webp 1387w',
      },
      alt: 'кепка',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/hatSmall-320-2024-10-28-09-48-58.png 320w, static/ny25/hatSmall-680-2024-10-28-09-48-58.png 854w',
        avif: 'static/ny25/hatSmall-320-2024-10-28-09-48-58.avif 320w, static/ny25/hatSmall-680-2024-10-28-09-48-58.avif 854w',
        webp: 'static/ny25/hatSmall-320-2024-10-28-09-48-58.webp 320w, static/ny25/hatSmall-680-2024-10-28-09-48-58.webp 854w',
      },
      alt: 'кепка',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/hatSmallOpened-320-2024-12-09-08-59-37.png 320w, static/ny25/hatSmallOpened-680-2024-12-09-08-59-37.png 854w',
        avif: 'static/ny25/hatSmallOpened-320-2024-12-09-08-59-37.avif 320w, static/ny25/hatSmallOpened-680-2024-12-09-08-59-37.avif 854w',
        webp: 'static/ny25/hatSmallOpened-320-2024-12-09-08-59-37.webp 320w, static/ny25/hatSmallOpened-680-2024-12-09-08-59-37.webp 854w',
      },
      alt: 'кепка',
    },
    defaultStatistic: {
      title: '1.5 млн ₽',
      description: 'Потратили клиенты Т-Банк на путешествия',
    },
    extraDescription: 'Так держать в следующем году!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'Мы желаем вам тратить еще больше, используя наш потрясающий банк! Кстати, вы можете взять у нас ипотеку, если вдруг будет настроение!',
      buttonLink: null,
    },
  },
  {
    name: 'sport',
    title: 'Бачок',
    imageLarge: {
      src: {
        png: 'static/ny25/lobster-320-2024-10-28-08-43-47.png 320w, static/ny25/lobster-760-2024-10-28-08-43-47.png 854w',
        avif: 'static/ny25/lobster-320-2024-10-28-08-43-47.avif 320w, static/ny25/lobster-760-2024-10-28-08-43-47.avif 854w',
        webp: 'static/ny25/lobster-320-2024-10-28-08-43-47.webp 320w, static/ny25/lobster-760-2024-10-28-08-43-47.webp 854w',
      },
      alt: 'рак',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/lobsterSmall-320-2024-10-28-09-48-58.png 320w, static/ny25/lobsterSmall-680-2024-10-28-09-48-58.png 854w',
        avif: 'static/ny25/lobsterSmall-320-2024-10-28-09-48-58.avif 320w, static/ny25/lobsterSmall-680-2024-10-28-09-48-58.avif 854w',
        webp: 'static/ny25/lobsterSmall-320-2024-10-28-09-48-58.webp 320w, static/ny25/lobsterSmall-680-2024-10-28-09-48-58.webp 854w',
      },
      alt: 'рак',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/lobsterSmallOpened-320-2024-12-09-09-04-27.png 320w, static/ny25/lobsterSmallOpened-680-2024-12-09-09-04-27.png 854w',
        avif: 'static/ny25/lobsterSmallOpened-320-2024-12-09-09-04-27.avif 320w, static/ny25/lobsterSmallOpened-680-2024-12-09-09-04-27.avif 854w',
        webp: 'static/ny25/lobsterSmallOpened-320-2024-12-09-09-04-27.webp 320w, static/ny25/lobsterSmallOpened-680-2024-12-09-09-04-27.webp 854w',
      },
      alt: 'рак',
    },
    defaultStatistic: {
      title: '1.5 млн ₽',
      description: 'Потратили клиенты Т-Банк на спорт',
    },
    extraDescription: '',
    bonusRedirectType: BonusRedirectType.Main,
    wishes: {
      title: ambassadorsWishes[Ambassador.Lapenko].title,
      avatar: ambassadorsWishes[Ambassador.Lapenko].avatar,
      text: 'Мы желаем вам тратить еще больше, используя наш потрясающий банк! Кстати, вы можете взять у нас ипотеку, если вдруг будет настроение!',
      buttonLink: null,
    },
  },
  {
    name: 'mobile',
    title: 'Деликатес',
    imageLarge: {
      src: {
        png: 'static/ny25/dishes-320-2024-12-09-10-43-49.png 320w, static/ny25/dishes-760-2024-12-09-10-43-49.png 854w',
        avif: 'static/ny25/dishes-320-2024-12-09-10-43-49.avif 320w, static/ny25/dishes-760-2024-12-09-10-43-49.avif 854w',
        webp: 'static/ny25/dishes-320-2024-12-09-10-43-49.webp 320w, static/ny25/dishes-760-2024-12-09-10-43-49.webp 854w',
      },
      alt: 'деликатес',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/dishesSmall-320-2024-11-28-12-41-53.png 320w, static/ny25/dishesSmall-680-2024-11-28-12-41-53.png 854w',
        avif: 'static/ny25/dishesSmall-320-2024-11-28-12-41-53.avif 320w, static/ny25/dishesSmall-680-2024-11-28-12-41-53.avif 854w',
        webp: 'static/ny25/dishesSmall-320-2024-11-28-12-41-53.webp 320w, static/ny25/dishesSmall-680-2024-11-28-12-41-53.webp 854w',
      },
      alt: 'деликатес',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/dishesSmallOpened-320-2024-12-09-10-42-18.png 320w, static/ny25/dishesSmallOpened-680-2024-12-09-10-42-18.png 854w',
        avif: 'static/ny25/dishesSmallOpened-320-2024-12-09-10-42-18.avif 320w, static/ny25/dishesSmallOpened-680-2024-12-09-10-42-18.avif 854w',
        webp: 'static/ny25/dishesSmallOpened-320-2024-12-09-10-42-18.webp 320w, static/ny25/dishesSmallOpened-680-2024-12-09-10-42-18.webp 854w',
      },
      alt: 'деликатес',
    },
    defaultStatistic: {
      title: '1.5 млн ₽',
      description: 'Потратили клиенты Т-Банк на связь',
    },
    extraDescription: 'Так держать в следующем году!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Ponaroshku].title,
      avatar: ambassadorsWishes[Ambassador.Ponaroshku].avatar,
      text: 'Мы желаем вам тратить еще больше, используя наш потрясающий банк! Кстати, вы можете взять у нас ипотеку, если вдруг будет настроение!',
      buttonLink: null,
    },
  },
  {
    name: 'food',
    title: 'Мармарис',
    imageLarge: {
      src: {
        png: 'static/ny25/plane-320-2024-10-28-08-59-28.png 320w, static/ny25/plane-760-2024-10-28-08-59-28.png 854w',
        avif: 'static/ny25/plane-320-2024-10-28-08-59-28.avif 320w, static/ny25/plane-760-2024-10-28-08-59-28.avif 854w',
        webp: 'static/ny25/plane-320-2024-10-28-08-59-28.webp 320w, static/ny25/plane-760-2024-10-28-08-59-28.webp 854w',
      },
      alt: 'самолет',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/planeSmall-320-2024-10-28-09-48-58.png 320w, static/ny25/planeSmall-680-2024-10-28-09-48-58.png 854w',
        avif: 'static/ny25/planeSmall-320-2024-10-28-09-48-58.avif 320w, static/ny25/planeSmall-680-2024-10-28-09-48-58.avif 854w',
        webp: 'static/ny25/planeSmall-320-2024-10-28-09-48-58.webp 320w, static/ny25/planeSmall-680-2024-10-28-09-48-58.webp 854w',
      },
      alt: 'самолет',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/planeSmallOpened-320-2024-12-09-09-08-14.png 320w, static/ny25/planeSmallOpened-680-2024-12-09-09-08-14.png 1387w',
        avif: 'static/ny25/planeSmallOpened-320-2024-12-09-09-08-14.avif 320w, static/ny25/planeSmallOpened-680-2024-12-09-09-08-14.avif 854w',
        webp: 'static/ny25/planeSmallOpened-320-2024-12-09-09-08-14.webp 320w, static/ny25/planeSmallOpened-680-2024-12-09-09-08-14.webp 854w',
      },
      alt: 'самолет',
    },
    defaultStatistic: {
      title: '1.5 млн ₽',
      description: 'Потратили клиенты Т-Банк на еду',
    },
    extraDescription: 'Успехов!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Academeg].title,
      avatar: ambassadorsWishes[Ambassador.Academeg].avatar,
      text: 'Мы желаем вам тратить еще больше, используя наш потрясающий банк! Кстати, вы можете взять у нас ипотеку, если вдруг будет настроение!',
      buttonLink: null,
    },
  },
  {
    name: 'auto',
    title: 'Домашние тапки',
    imageLarge: {
      src: {
        png: 'static/ny25/ducks-320-2024-10-28-08-43-47.png 320w, static/ny25/ducks-760-2024-10-28-08-43-47.png 854w',
        avif: 'static/ny25/ducks-320-2024-10-28-08-43-47.avif 320w, static/ny25/ducks-760-2024-10-28-08-43-47.avif 854w',
        webp: 'static/ny25/ducks-320-2024-10-28-08-43-47.webp 320w, static/ny25/ducks-760-2024-10-28-08-43-47.webp 854w',
      },
      alt: 'утки',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/ducksSmall-320-2024-10-28-09-54-22.png 320w, static/ny25/ducksSmall-680-2024-10-28-09-54-22.png 854w',
        avif: 'static/ny25/ducksSmall-320-2024-10-28-09-54-22.avif 320w, static/ny25/ducksSmall-680-2024-10-28-09-54-22.avif 854w',
        webp: 'static/ny25/ducksSmall-320-2024-10-28-09-54-22.webp 320w, static/ny25/ducksSmall-680-2024-10-28-09-54-22.webp 854w',
      },
      alt: 'утки',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/ducksSmallOpened-320-2024-12-09-09-06-35.png 320w, static/ny25/ducksSmallOpened-680-2024-12-09-09-06-35.png 854w',
        avif: 'static/ny25/ducksSmallOpened-320-2024-12-09-09-06-35.avif 320w, static/ny25/ducksSmallOpened-680-2024-12-09-09-06-35.avif 854w',
        webp: 'static/ny25/ducksSmallOpened-320-2024-12-09-09-06-35.webp 320w, static/ny25/ducksSmallOpened-680-2024-12-09-09-06-35.webp 854w',
      },
      alt: 'утки',
    },
    defaultStatistic: {
      title: '1.5 млн ₽',
      description: 'Потратили клиенты Т-Банк на автомобили',
    },
    extraDescription: 'Вы молодец!',
    bonusRedirectType: BonusRedirectType.Main,
    wishes: {
      title: ambassadorsWishes[Ambassador.Academeg].title,
      avatar: ambassadorsWishes[Ambassador.Academeg].avatar,
      text: 'Мы желаем вам тратить еще больше, используя наш потрясающий банк! Кстати, вы можете взять у нас ипотеку, если вдруг будет настроение!',
      buttonLink: {
        text: 'В магазин',
        href: 'https://www.tbank.ru/',
      },
    },
  },
  {
    name: 'marketplace',
    title: 'Доставочка',
    imageLarge: {
      src: {
        png: 'static/ny25/squirrel-320-2024-12-09-09-14-27.png 320w, static/ny25/squirrel-760-2024-12-09-09-14-27.png 854w',
        avif: 'static/ny25/squirrel-320-2024-12-09-09-14-27.avif 320w, static/ny25/squirrel-760-2024-12-09-09-14-27.avif 854w',
        webp: 'static/ny25/squirrel-320-2024-12-09-09-14-27.webp 320w, static/ny25/squirrel-760-2024-12-09-09-14-27.webp 854w',
      },
      alt: 'белка',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/squirrelSmall-320-2024-11-19-08-09-43.png 320w, static/ny25/squirrelSmall-680-2024-11-19-08-09-43.png 854w',
        avif: 'static/ny25/squirrelSmall-320-2024-11-19-08-09-43.avif 320w, static/ny25/squirrelSmall-680-2024-11-19-08-09-43.avif 854w',
        webp: 'static/ny25/squirrelSmall-320-2024-11-19-08-09-43.webp 320w, static/ny25/squirrelSmall-680-2024-11-19-08-09-43.webp 854w',
      },
      alt: 'белка',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/squirrelSmallOpened-320-2024-12-09-09-13-09.png 320w, static/ny25/squirrelSmallOpened-680-2024-12-09-09-13-09.png 854w',
        avif: 'static/ny25/squirrelSmallOpened-320-2024-12-09-09-13-09.avif 320w, static/ny25/squirrelSmallOpened-680-2024-12-09-09-13-09.avif 854w',
        webp: 'static/ny25/squirrelSmallOpened-320-2024-12-09-09-13-09.webp 320w, static/ny25/squirrelSmallOpened-680-2024-12-09-09-13-09.webp 854w',
      },
      alt: 'белка',
    },
    defaultStatistic: null,
    extraDescription: '',
    bonusRedirectType: BonusRedirectType.Main,
    wishes: {
      title: ambassadorsWishes[Ambassador.Academeg].title,
      avatar: ambassadorsWishes[Ambassador.Academeg].avatar,
      text: 'Мы желаем вам тратить еще больше, используя наш потрясающий банк! Кстати, вы можете взять у нас ипотеку, если вдруг будет настроение!',
      buttonLink: null,
    },
  },
  {
    name: 'hugeBenefit',
    title: 'Кибер cюрприз',
    imageLarge: {
      src: {
        png: 'static/ny25/surprise-320-2024-12-09-11-29-11.png 320w, static/ny25/surprise-760-2024-12-09-11-29-11.png 854w',
        avif: 'static/ny25/surprise-320-2024-12-09-11-29-11.avif 320w, static/ny25/surprise-760-2024-12-09-11-29-11.avif 854w',
        webp: 'static/ny25/surprise-320-2024-12-09-11-29-11.webp 320w, static/ny25/surprise-760-2024-12-09-11-29-11.webp 854w',
      },
      alt: 'Кибер cюрприз',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/surpriseSmall-320-2024-12-09-11-27-58.png 320w, static/ny25/surpriseSmall-681-2024-12-09-11-27-58.png 854w',
        avif: 'static/ny25/surpriseSmall-320-2024-12-09-11-27-58.avif 320w, static/ny25/surpriseSmall-681-2024-12-09-11-27-58.avif 854w',
        webp: 'static/ny25/surpriseSmall-320-2024-12-09-11-27-58.webp 320w, static/ny25/surpriseSmall-681-2024-12-09-11-27-58.webp 854w',
      },
      alt: 'Кибер cюрприз',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/surpriseSmallOpened-320-2024-12-09-11-26-48.png 320w, static/ny25/surpriseSmallOpened-680-2024-12-09-11-26-48.png 1387w',
        avif: 'static/ny25/surpriseSmallOpened-320-2024-12-09-11-26-48.avif 320w, static/ny25/surpriseSmallOpened-680-2024-12-09-11-26-48.avif 854w',
        webp: 'static/ny25/surpriseSmallOpened-320-2024-12-09-11-26-48.webp 320w, static/ny25/surpriseSmallOpened-680-2024-12-09-11-26-48.webp 1387w',
      },
      alt: 'Кибер cюрприз',
    },
    defaultStatistic: {
      title: '73 млрд ₽',
      description:
        'Столько кэшбэка мы выплатили клиентам в этом году. На эти деньги можно было сделать около 92,5 млн бутербродов с черной икрой.',
    },
    extraDescription: 'Ваши финансы работали с умом. Сладкая математика в новогодней обертке!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Желаю в новом году ловить выгоду, как рыбу в реке!',
      buttonLink: null,
    },
  },
  {
    name: 'secMB',
    title: 'Ирис В-приложении-завис',
    imageLarge: {
      src: {
        png: 'static/ny25/Iris-320-2024-12-09-11-08-39.png 320w, static/ny25/Iris-760-2024-12-09-11-08-39.png 854w',
        avif: 'static/ny25/Iris-320-2024-12-09-11-08-39.avif 320w, static/ny25/Iris-760-2024-12-09-11-08-39.avif 854w',
        webp: 'static/ny25/Iris-320-2024-12-09-11-08-39.webp 320w, static/ny25/Iris-760-2024-12-09-11-08-39.webp 854w',
      },
      alt: 'ирис',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/IrisSmall-320-2024-12-09-11-07-18.png 320w, static/ny25/IrisSmall-681-2024-12-09-11-07-18.png 854w',
        avif: 'static/ny25/IrisSmall-320-2024-12-09-11-07-18.avif 320w, static/ny25/IrisSmall-681-2024-12-09-11-07-18.avif 854w',
        webp: 'static/ny25/IrisSmall-320-2024-12-09-11-07-18.webp 320w, static/ny25/IrisSmall-681-2024-12-09-11-07-18.webp 1387w',
      },
      alt: 'ирис',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/IrisSmallOpened-320-2024-12-09-11-05-56.png 320w, static/ny25/IrisSmallOpened-680-2024-12-09-11-05-56.png 854w',
        avif: 'static/ny25/IrisSmallOpened-320-2024-12-09-11-05-56.avif 320w, static/ny25/IrisSmallOpened-680-2024-12-09-11-05-56.avif 854w',
        webp: 'static/ny25/IrisSmallOpened-320-2024-12-09-11-05-56.webp 320w, static/ny25/IrisSmallOpened-680-2024-12-09-11-05-56.webp 854w',
      },
      alt: 'ирис',
    },
    defaultStatistic: {
      title: '38 млрд',
      description:
        'Столько минут провели в мобильном приложении Т‑Банка все наши клиенты. За это время можно было 202 млн раз посмотреть «Иронию судьбы, или С легким паром!».',
    },
    extraDescription: 'Получилась самая яркая конфета года!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Chebatkov].title,
      avatar: ambassadorsWishes[Ambassador.Chebatkov].avatar,
      text: 'С легким банкингом!',
      buttonLink: null,
    },
  },
  {
    name: 'deposit',
    title: 'Миллиончик',
    imageLarge: {
      src: {
        png: 'static/ny25/million-320-2024-12-09-09-41-46.png 320w, static/ny25/million-760-2024-12-09-09-41-46.png 854w',
        avif: 'static/ny25/million-320-2024-12-09-09-41-46.avif 320w, static/ny25/million-760-2024-12-09-09-41-46.avif 854w',
        webp: 'static/ny25/million-320-2024-12-09-09-41-46.webp 320w, static/ny25/million-760-2024-12-09-09-41-46.webp 854w',
      },
      alt: 'лимон',
    },
    imageSmall: {
      src: {
        png: 'static/ny25/millionSmall-320-2024-11-26-12-43-18.png 320w, static/ny25/millionSmall-680-2024-11-26-12-43-18.png 854w',
        avif: 'static/ny25/millionSmall-320-2024-11-26-12-43-18.avif 320w, static/ny25/millionSmall-680-2024-11-26-12-43-18.avif 854w',
        webp: 'static/ny25/millionSmall-320-2024-11-26-12-43-18.webp 320w, static/ny25/millionSmall-680-2024-11-26-12-43-18.webp 854w',
      },
      alt: 'лимон',
    },
    imageSmallOpened: {
      src: {
        png: 'static/ny25/millionSmallOpened-320-2024-12-09-09-40-23.png 320w, static/ny25/millionSmallOpened-680-2024-12-09-09-40-23.png 854w',
        avif: 'static/ny25/millionSmallOpened-320-2024-12-09-09-40-23.avif 320w, static/ny25/millionSmallOpened-680-2024-12-09-09-40-23.avif 854w',
        webp: 'static/ny25/millionSmallOpened-320-2024-12-09-09-40-23.webp 320w, static/ny25/millionSmallOpened-680-2024-12-09-09-40-23.webp 854w',
      },
      alt: 'лимон',
    },
    defaultStatistic: {
      title: '666 971',
      description:
        'Столько финансовых целей по накопительным счетам достигли клиенты Т‑Банка за год. Собрали огромную коробку сладких побед!',
    },
    extraDescription: 'Эта конфета — со вкусом правильных решений!',
    bonusRedirectType: BonusRedirectType.Bonuses,
    wishes: {
      title: ambassadorsWishes[Ambassador.Kuruch].title,
      avatar: ambassadorsWishes[Ambassador.Kuruch].avatar,
      text: 'Желаю, чтобы в следующем году ваши финансовые запасы не истощались, как запасы хлеба на утро понедельника!',
      buttonLink: null,
    },
  },
];

export const mockStatisticValidationConfig: NamedValidationConfig[] = [
  {
    name: 'favorite_pets_shop',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'pets_total_spends',
    rules: [
      {
        name: StatisticItemValidationType.NonNegative,
        value: true,
      },
      {
        name: StatisticItemValidationType.SignsAfterComma,
        value: MAX_STATISTIC_ITEM_FLOAT_VALUE_SIGNS_AFTER_COMMA,
      },
    ],
  },
  {
    name: 'travels_total_spends',
    rules: [
      {
        name: StatisticItemValidationType.NonNegative,
        value: true,
      },
      {
        name: StatisticItemValidationType.SignsAfterComma,
        value: MAX_STATISTIC_ITEM_FLOAT_VALUE_SIGNS_AFTER_COMMA,
      },
    ],
  },
  {
    name: 'favorite_travel_company',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'gym_total_quantity',
    rules: [
      {
        name: StatisticItemValidationType.NonNegative,
        value: true,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'gym_total_spends',
    rules: [
      {
        name: StatisticItemValidationType.NonNegative,
        value: true,
      },
      {
        name: StatisticItemValidationType.SignsAfterComma,
        value: MAX_STATISTIC_ITEM_FLOAT_VALUE_SIGNS_AFTER_COMMA,
      },
    ],
  },
  {
    name: 'gym_average_visits',
    rules: [
      {
        name: StatisticItemValidationType.NonNegative,
        value: true,
      },
      {
        name: StatisticItemValidationType.Integer,
        value: true,
      },
    ],
  },
  {
    name: 'mobile_average_call_duration',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: ONE_MINUTE_IN_SECONDS,
      },
      {
        name: StatisticItemValidationType.Seconds,
        value: ONE_MINUTE_IN_SECONDS,
      },
    ],
  },
  {
    name: 'amt_2025_tran_amt',
    rules: [
      {
        name: StatisticItemValidationType.WhiteListNumber,
        value: AMT_2025_TRAN_AMT_WHITE_LIST,
      },
    ],
  },
  {
    name: 'favorite_food',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'favorite_drink',
    rules: [
      {
        name: StatisticItemValidationType.MinStringLength,
        value: MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.MaxStringLength,
        value: MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH,
      },
      {
        name: StatisticItemValidationType.UpperCaseString,
        value: true,
      },
    ],
  },
  {
    name: 'amt_2025_tran_dt',
    rules: [
      {
        name: StatisticItemValidationType.DayMonthDate,
        value: true,
      },
    ],
  },
  {
    name: 'min_spend_tran_amt_rur',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: 0,
      },
      {
        name: StatisticItemValidationType.RoundNumber,
        value: true,
      },
    ],
  },
  {
    name: 'mb_sec',
    rules: [
      {
        name: StatisticItemValidationType.MoreThanValue,
        value: SECONDS_VALIDATION_MULTIPLIER * ONE_MINUTE_IN_SECONDS,
      },
      {
        name: StatisticItemValidationType.Seconds,
        value: ONE_MINUTE_IN_SECONDS,
      },
    ],
  },
];
